import { GROUP_COLOR_NAME } from './groupColors';
import { speedWord } from './speedWords';

const first = (value) => Array.isArray(value) ? value.find(Boolean) : null;

export const loopGroup = (loop = {}) => {
  if (loop.instrument_group) return loop.instrument_group;
  return Object.entries(GROUP_COLOR_NAME).find(([, color]) => color === loop.color_pack)?.[0] || '';
};

export const loopCardModel = (loop = {}) => {
  const group = loopGroup(loop);
  const style = first(loop.style_tags);
  const bpm = Number(loop.bpm);
  // Number(null) is 0, so a loop with no BPM would read "0 BPM" and get a made-up speed word.
  const hasBpm = loop.bpm != null && Number.isFinite(bpm) && bpm > 0;
  const chips = [
    hasBpm && `${bpm} BPM`,
    loop.key,
    loop.bars != null && `${loop.bars} bars`,
    loop.energy != null && `Energy ${loop.energy}`,
  ].filter(Boolean);
  return {
    group,
    label: group === 'Melodies' ? 'MELODY' : group === 'Textures' ? 'TEXTURE' : group === 'Drums' ? 'DRUMS' : group === 'Sound FX' ? 'SOUND FX' : 'LOOP',
    headline: loop.mood_category || style || group || 'Loop',
    feel: [hasBpm ? speedWord(bpm) : null, style].filter(Boolean).join(' · '),
    chips,
  };
};
